import { 
  Activity, 
  Dumbbell, 
  Droplets, 
  BookOpen, 
  Sun, 
  Moon, 
  Briefcase, 
  Heart, 
  Star, 
  Zap, 
  Coffee, 
  Utensils, 
  BedDouble, 
  Music, 
  Users, 
  Home, 
  DollarSign, 
  Smartphone, 
  Code, 
  PenTool,
  Footprints,
  Leaf,
  Search,
  Book,
  Brain,
  Bike,
  Camera,
  Clock,
  Cloud,
  Compass,
  Feather,
  Flame,
  Glasses,
  Headphones,
  Lightbulb,
  Mail,
  Mountain,
  Palette,
  Pencil,
  Phone,
  Pizza,
  Podcast,
  Rocket,
  ShoppingBag,
  Smile,
  Sparkles,
  Target,
  Trophy,
  Umbrella,
  Video,
  Wallet,
  Watch,
  Wind,
  Wrench,
  AlarmClock,
  Apple,
  Award,
  Battery,
  Bell,
  Calculator,
  Calendar,
  CheckCircle,
  Circle,
  Clipboard,
  CloudRain,
  CreditCard,
  Database,
  Download,
  Edit,
  Eye,
  Film,
  Flag,
  Folder,
  Gift,
  Globe,
  Hash,
  Inbox,
  Key,
  Layers,
  List,
  Lock,
  MapPin,
  MessageCircle,
  Mic,
  Monitor,
  MoreHorizontal,
  Navigation,
  Package,
  Paperclip,
  Play,
  Plus,
  Printer,
  Radio,
  RefreshCw,
  Save,
  Send,
  Settings,
  Share,
  Shield,
  ShoppingCart,
  Shuffle,
  Sliders,
  Speaker,
  Tag,
  ThumbsUp,
  Trash2,
  TrendingUp,
  Tv,
  Upload,
  User,
  Volume2,
  Wifi,
  X,
  type LucideIcon
} from 'lucide-react';

// Type-safe icon map using `as const`
export const ICON_MAP = {
  Activity,
  Dumbbell,
  Droplets,
  BookOpen,
  Sun,
  Moon,
  Briefcase,
  Heart,
  Star,
  Zap,
  Coffee,
  Utensils,
  BedDouble,
  Music,
  Users,
  Home,
  DollarSign,
  Smartphone,
  Code,
  PenTool,
  Footprints,
  Leaf,
  Search,
  Book,
  Brain,
  Bike,
  Camera,
  Clock,
  Cloud,
  Compass,
  Feather,
  Flame,
  Glasses,
  Headphones,
  Lightbulb,
  Mail,
  Mountain,
  Palette,
  Pencil,
  Phone,
  Pizza,
  Podcast,
  Rocket,
  ShoppingBag,
  Smile,
  Sparkles,
  Target,
  Trophy,
  Umbrella,
  Video,
  Wallet,
  Watch,
  Wind,
  Wrench,
  AlarmClock,
  Apple,
  Award,
  Battery,
  Bell,
  Calculator,
  Calendar,
  CheckCircle,
  Circle,
  Clipboard,
  CloudRain,
  CreditCard,
  Database,
  Download,
  Edit,
  Eye,
  Film,
  Flag,
  Folder,
  Gift,
  Globe,
  Hash,
  Inbox,
  Key,
  Layers,
  List,
  Lock,
  MapPin,
  MessageCircle,
  Mic,
  Monitor,
  MoreHorizontal,
  Navigation,
  Package,
  Paperclip,
  Play,
  Plus,
  Printer,
  Radio,
  RefreshCw,
  Save,
  Send,
  Settings,
  Share,
  Shield,
  ShoppingCart,
  Shuffle,
  Sliders,
  Speaker,
  Tag,
  ThumbsUp,
  Trash2,
  TrendingUp,
  Tv,
  Upload,
  User,
  Volume2,
  Wifi,
  X,
} as const;

// Type for valid icon names
export type IconName = keyof typeof ICON_MAP;

// Array of available icon names for iteration
export const AVAILABLE_ICONS: IconName[] = Object.keys(ICON_MAP) as IconName[];

// Helper function to safely get an icon (returns Activity as fallback)
export function getIcon(name: string): LucideIcon {
  if (name in ICON_MAP) {
    return ICON_MAP[name as IconName];
  }
  return Activity;
}
